var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({
    height: '100%',
    'background-image': 'url(' + require('@/assets/app/background.jpg') + ')',
    'background-position': 'center',
    'background-attachment': 'fixed',
    'background-size': 'cover'
  })},[_c('v-snackbar',{staticStyle:{"z-index":"99 !important","padding":"0 !important"},attrs:{"timeout":5000,"app":"","centered":"","top":"","elevation":"10","light":""},model:{value:(_vm.snackbar.mostrar),callback:function ($$v) {_vm.$set(_vm.snackbar, "mostrar", $$v)},expression:"snackbar.mostrar"}},[_c('v-alert',{staticClass:"mb-0",attrs:{"border":"top","type":_vm.snackbar.color,"text":"","prominent":""},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-btn',{staticClass:"ml-2",attrs:{"icon":""},on:{"click":function($event){return _vm.cerrarAlerta()}}},[_c('v-icon',{attrs:{"color":_vm.snackbar.color}},[_vm._v("mdi-close-circle-outline")])],1)]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.snackbar.mensaje)+" ")])],1),(
      _vm.rutaActual &&
      _vm.rutaActual !== 'login' &&
      _vm.rutaActual !== 'crear_contrasena' &&
      _vm.rutaActual !== 'mantencion'
    )?_c('app-side-bar'):_vm._e(),(
      _vm.rutaActual &&
      _vm.rutaActual !== 'login' &&
      _vm.rutaActual !== 'crear_contrasena' &&
      _vm.rutaActual !== 'mantencion'
    )?_c('app-toolbar'):_vm._e(),(
      _vm.env === 'production' &&
      _vm.rutaActual &&
      _vm.rutaActual !== 'login' &&
      _vm.rutaActual !== 'mantencion'
    )?_c('v-idle',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"loop":true,"reminders":[30],"wait":5,"duration":360},on:{"idle":_vm.onidle,"remind":_vm.onremind}}):_vm._e(),_c('v-main',{staticClass:"mb-10"},[_c('router-view')],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }